import React, { useEffect } from 'react';
import useLocationName from '../../../Hooks/useLocationName';
import { Paper, Divider, Tooltip, Fab } from '@mui/material';
import { FullSizeColumn } from '../../FlexBox';
import Header from './Header';
import AddIcon from '@mui/icons-material/Add';
import { useAtom, useAtomValue } from 'jotai';
import { searchValuesAtom } from '../../../Atoms';
import { notifyEndCallAtom } from '../../../Atoms/HubAtoms';
import EntryListWrapper from './EntryListWrapper';
import { applyCallFilter } from '../../../Helpers/Filters/constants';
import applyFilters from '../../../Helpers/Filters/applyFilters';
import applySorting from '../../../Helpers/Filters/applySorting';

const EntriesWrapper = function EntriesWrapper({
  disableClickRow = false,
  customStatusChipCallback = null,
  rowSxCallback = null,
  customEntryFunction = undefined,
  hideFilters = false,
  customFilters = null,
  filtersLayout = null,
  headerActions = null,
  fab = null,
  fabVariant = null,
  onClickFab = null,
  customFab = null,
  title = '',
  ObserverWrapper,
  ExportToExcel = null,
  providedHeight = null,
  providedWidth = null,
  hideExportExcel = false,
  hideSorting = false,
  hideSearchBar = false,
  singlePageList = null,
  caption = null,
  removeFromList = null,
  updateItem = null,
  sortingOptions = [],
  wavePeriod = '',
  filters = [],
  columns = {},
  customClick = undefined,
}) {
  const locationName = useLocationName();
  const notifyEndCall = useAtomValue(notifyEndCallAtom);
  const [searchValues, setSearchValues] = useAtom(searchValuesAtom);

  const applyDefaultFiltersAndSorting = () => {
    let callFilter = null;
    if (
      Object.prototype.hasOwnProperty.call(filters, 'called') ||
      Object.prototype.hasOwnProperty.call(filters, 'lastCallInCurrentMonth')
    )
      callFilter = applyCallFilter(
        title === 'BIRTHDAYS',
        JSON.parse(localStorage.getItem('lastCallInCurrentMonth')) !== null
          ? JSON.parse(localStorage.getItem('lastCallInCurrentMonth'))
          : JSON.parse(localStorage.getItem('called'))
      );
    setSearchValues({
      ...applyFilters(filters),
      subsectionId: JSON.parse(
        localStorage.getItem(`${location?.pathname?.substring(1)}-subsectionId`)
      ),
      ...applySorting(sortingOptions),
      ...(callFilter || {}), //always after applyFilters to overwrite the callFilter object
    });
  };

  useEffect(() => {
    applyDefaultFiltersAndSorting();
  }, [location]);

  useEffect(() => {
    if (!searchValues) {
      applyDefaultFiltersAndSorting();
    }
  }, [searchValues]);

  useEffect(() => {
    if (
      notifyEndCall &&
      searchValues &&
      (searchValues.called === 0 || searchValues.lastCallInCurrentMonth === 0)
    ) {
      removeFromList(notifyEndCall?.baseEntityId);
    }
  }, [notifyEndCall?.id]);

  return (
    <Paper
      id="entries-wrapper"
      sx={{
        flex: `2 1 ${providedWidth}`,
        height: providedHeight,
        overflow: 'hidden',
      }}
    >
      <FullSizeColumn>
        <Header
          title={title}
          caption={caption}
          hideSearchBar={hideSearchBar}
          hideExportExcel={hideExportExcel}
          hideSorting={hideSorting}
          hideFilters={hideFilters}
          sortingOptions={sortingOptions}
          searchValues={searchValues}
          setSearchValues={setSearchValues}
          customFilters={customFilters}
          filtersLayout={filtersLayout}
          headerActions={headerActions}
          handleExportToExcel={ExportToExcel}
        />
        <Divider />
        <EntryListWrapper
          disableClickRow={disableClickRow}
          customStatusChipCallback={customStatusChipCallback}
          rowSxCallback={rowSxCallback}
          singlePageList={singlePageList}
          ObserverWrapper={ObserverWrapper}
          wavePeriod={wavePeriod}
          updateItem={updateItem}
          columns={columns}
          customEntryFunction={customEntryFunction}
          currentSection={locationName}
          customClick={customClick}
        />
      </FullSizeColumn>
      {customFab
        ? customFab
        : fab && (
            <Tooltip title={fab} placement="bottom" variant={fabVariant}>
              <Fab
                color="primary"
                aria-label={fab}
                data-testid="section-fab"
                onClick={onClickFab}
                sx={{
                  position: 'absolute',
                  bottom: 30,
                  right: 30,
                }}
              >
                <AddIcon />
                {fabVariant ? fab : null}
              </Fab>
            </Tooltip>
          )}
    </Paper>
  );
};

export default EntriesWrapper;
